<script setup>
import InputError from "@/Components/InputError.vue";
import PrimaryBtn from "@/Components/PrimaryBtn.vue";
import InputField from "@/Components/InputField.vue";
import InputLabel from "@/Components/InputLabel.vue";

import { defineProps, ref, computed, watch, inject } from "vue";
import Swal from "sweetalert2";
import { useForm } from "@inertiajs/vue3";
import { status } from "nprogress";
const route = inject('route');
const props = defineProps({
  isOpen: {
    type: Boolean,
    required: true,
  },
  title: {
    type: String,
    required: true,
  },

  slider: {
    type: Object,
    required: true,
  },
});

const emit = defineEmits(["update:isOpen"]);

const form = useForm({
  id: null,
  judul: "",
  deskripsi: "",
  status: "",
});

watch(
  () => props.slider,
  (newSlider) => {
    if (newSlider) {
      form.id = newSlider.id;
      form.idslider = newSlider.idslider;
      form.judul = newSlider.judul;
      form.deskripsi = newSlider.deskripsi;
      form.status = newSlider.status;
    }
  },
  { immediate: true, deep: true }
);

const closeModal = () => {
  emit("update:isOpen", false);
};

const handleClickOutside = (event) => {
  if (event.target === event.currentTarget) {
    closeModal();
  }
};

const submit = () => {
  form.put(route("sliders.update", form.idslider), {
    onSuccess: () => {
      form.reset();
      closeModal();
    },
  });
};
</script>
<template>
  <div
    v-if="isOpen"
    class="fixed inset-0 z-50 flex items-start justify-center pt-10 bg-black/60 sm:items-center sm:pt-0"
    @click="handleClickOutside"
  >
    <div
      class="relative w-full h-auto max-h-[90vh] p-4 overflow-y-auto bg-white rounded-xl shadow-2xl sm:w-1/2 sm:p-8"
    >
      <div class="flex items-center justify-between mb-8">
        <h2 class="text-2xl font-bold">{{ title }}</h2>
        <button
          type="button"
          aria-label="Close"
          @click="closeModal"
          class="transition text-neutral-400 hover:text-neutral-700"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="w-7 h-7"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M6 18L18 6M6 6l12 12"
            />
          </svg>
        </button>
      </div>
      <form class="space-y-7" @submit.prevent="submit">
        <div>
          <InputField label="Nama Dokumen" icon="pen" v-model="form.judul" />
          <InputError :message="form.errors.judul" class="mt-2" />
        </div>
        <div>
          <label for="Deskripsi" class="block mb-1 font-medium text-neutral-700"
            >Deskripsi</label
          >
          <textarea
            class="w-full p-3 text-sm border rounded-lg border-neutral-200 focus:ring-2 focus:ring-primary-500 focus:border-primary-500"
            placeholder="Deskripsi"
            rows="5"
            v-model="form.deskripsi"
          ></textarea>
          <InputError :message="form.errors.deskripsi" />
        </div>
        <div>
          <InputLabel for="status" value="Status" />
          <select
            v-model="form.status"
            class="w-full p-3 text-sm border rounded-lg border-neutral-200 focus:ring-2 focus:ring-primary-500 focus:border-primary-500"
          >
            <option value="" disabled selected>Pilih Status</option>
            <option value="1">Aktif</option>
            <option value="0">Nonaktif</option>
          </select>
          <InputError :message="form.errors.status" class="mt-2" />
        </div>

        <div>
          <PrimaryBtn :disabled="form.processing">
            <i class="fa-solid fa-floppy-disk"></i> Simpan
          </PrimaryBtn>
        </div>
      </form>
    </div>
  </div>
</template>
